<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container v-else grid-list-xl fluid>
            <v-row>
                <v-col lg="12">
                    <data-table
                        ref="tableCliente"
                        :tableName="'Clientes'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        :perPage="[10, 25, 50, 100]"
                        :showAdvancedFilters="false"
                    >
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar" style="padding-right: 12px;">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>

                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td>
                                    <div class="tblPrincipal">{{ item.nombre }}</div>
                                    <div class="tblSecundario">{{ item.correo }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ item.telefono }}</div>
                                </td>
                                <td>
                                    <div v-if="item.nominas">Nóminas</div>
                                    <div v-else>GDTH</div>
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    @click="abrirModal('update', item)"
                                                    small
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    depressed
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    @click="eliminar(item.id, item.nombre)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <template>
            <v-dialog v-model="dialog" persistent max-width="600px" scrollable>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>

                <perfect-scrollbar style="background:#FFF">
                    <v-card elevation="0">
                        <v-card-title class="justify-center card_titulo">
                            <div class="headerModal">
                                <img :src="imagen" class="imgModal" />
                                <h2 class="titleModal">{{ titulo_modal }}</h2>
                            </div>
                        </v-card-title>

                        <v-card-text class="card_texto">
                            <div id="loadingModal" v-show="!finaliza_carga">
                                <div id="loading">
                                    <v-progress-circular
                                    indeterminate
                                    :size="100"
                                    :width="7"
                                    color="blue"
                                    ></v-progress-circular>
                                </div>
                            </div>

                            <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                <v-divider class="divider"></v-divider>
                                <v-row>
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                        <v-text-field
                                            outlined
                                            autofocus
                                            label="Nombre"
                                            v-model="cliente.nombre"
                                            v-validate="'required'"
                                            data-vv-name="Nombre"
                                            :error-messages="errors.collect('Nombre')"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Correo"
                                            v-model="cliente.correo"
                                            required
                                            id="email"
                                            v-validate="'required|email'"
                                            data-vv-name="Correo"
                                            :error-messages="errors.collect('Correo')"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Teléfono"
                                            v-model="cliente.telefono"
                                            mask="phone"
                                            v-validate="'required'"
                                            data-vv-name="Telefono"
                                            :error-messages="errors.collect('Telefono')"
                                            auto
                                            v-mask="'(###) ###-####'"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Código postal"
                                            v-model="busca_cp"
                                            v-validate="'required'"
                                            data-vv-name="Código postal"
                                            :error-messages="errors.collect('Código postal')"
                                            @keyup.enter="busca_codigos()"
                                            v-on:keydown.tab="busca_codigos()"
                                            v-mask="'#####'"
                                        />
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Estado"
                                            v-model="estado"
                                            disabled
                                        />
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Municipio"
                                            v-model="municipio"
                                            disabled
                                        />
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="8" md="8" lg="8" xl="8" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Dirección"
                                            v-model="cliente.direccion"
                                            required
                                            v-validate="'required'"
                                            data-vv-name="Dirección"
                                            :error-messages="errors.collect('Dirección')"
                                        />
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                        <v-autocomplete
                                            outlined
                                            :items="colonias"
                                            item-text="nombre"
                                            item-value="id"
                                            label="Colonia"
                                            persistent-hint
                                            v-model="cliente.colonia_id"
                                            v-validate="'required'"
                                            data-vv-name="Colonia"
                                            :error-messages="errors.collect('Colonia')"
                                        />
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                        <h2 class="preguntaNomina">¿El cliente cuenta con el sistema de nómina?</h2>
                                        <v-switch
                                            class="pa-0 ma-0"
                                            v-model="cliente.nominas"
                                            :label="cliente.nominas ? 'Nómina activa':'Nómina inactiva'"
                                        ></v-switch>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button
                                class="btnCerrar"
                                @click="cerrarModal()"
                                :disabled="loading_guardar"
                            >
                                Cancelar
                            </button>
                            <v-btn
                                class="btnGuardar"
                                @click="guardar()"
                                :loading="loading_guardar"
                            >
                                Guardar
                            </v-btn>  
                        </v-card-actions>
                    </v-card>
                </perfect-scrollbar>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Datatable from "@/components/datatable/Datatable.vue";
import clientesApi from "../api/clientes";
import catalogoApis from "../api/catalogos";
import Notify from "@/plugins/notify";
import PerfectScrollbar from "perfect-scrollbar";

//comentario para borrar despues del push de prueba
export default {
    components: {
        "data-table": Datatable,
    },
    data() {
        return {
            url: "clientes/find",
            columns: [
                {
                    label: "Nombre",
                    name: "nombre",
                    filterable: true,
                },
                {
                    label: "Teléfono",
                    name: "telefono",
                    filterable: true,
                },
                {
                    label: 'Sistema',
                    name: 'sistema',
                    filterable: false
                },
                {
                    label: "Opciones",
                    name: "opciones",
                    filterable: false,
                    align: 'center'
                },
            ],
            filters: {
                activo          : true,
                paginate        : true,
                include_padres  : true,
                order_by        : 'nombre',
            },
            loading_guardar : false,
            loading         : true,
            dialog          : false,
            datosLogin      : "",
            cliente: {
                id          : "",
                nombre      : "",
                telefono    : "",
                correo      : "",
                direccion   : "",
                estado_id   : null,
                municipio_id: null,
                cp_id       : null,
                colonia_id  : null,
                nominas     : false,
            },
            estado_id       : null,
            municipio_id    : null,
            codigo_postal_id: null,
            empresas        : [],
            codigosP        : [],
            colonias        : [],
            titulo_modal    : "",
            finaliza_carga  : false,
            parametros_base : { activo: true, paginate: false, order: "asc" },
            accion          : "",
            imagen          : "",
            rol             : "",
            busca_cp        : "",
            municipio       : "",
            estado          : "",
        };
    },
    watch: {
        busca_cp: function(val){
            if(val != null){
                if(val.length == 5){
                    this.busca_codigos();
                }
                else{
                    this.estado = "";
                    this.municipio = "";
                    this.colonias = [];
                }
            }
        }
    },
    methods: {
        busca_codigos() {
            let self = this;
            let params = {
                activo: true,
                nombre: this.busca_cp,
                include_padres: true,
            };
                
            catalogoApis.getCP(params).then((response) => {
                let result = response.data;

                if (result.length == 0) {
                    Notify.ErrorToast("No se encontro el Código postal.");
                    this.estado = "";
                    this.municipio = "";
                    this.colonias = [];
                    return;
                }
                this.estado = result[0].nomb_estado;
                this.municipio = result[0].nomb_mun;
                this.cliente.estado_id = result[0].estado_id;
                this.cliente.municipio_id = result[0].municipio_id;
                this.cliente.cp_id = result[0].id;

                catalogoApis.getColonias({ codigo_postal_id: result[0].id, order: "asc", paginate:false }).then((response) => {
                    self.colonias = response.data;
                    if (self.accion == "update") {
                        self.finaliza_carga = true;
                    }
                })
                .catch((e) => {
                    Notify.ErrorToast("Se presento un problema al cargar las colonias.");
                    return;
                });
            })
            .catch((e) => {
                console.log(e);
                Notify.ErrorToast("Ocurrió un error al cargar los estados y ciudades.");
            });
        },
        async getCP(id) {
            await catalogoApis.getCodigoPostal(id).then((response) => {
                this.busca_cp = response.nombre;
                this.busca_codigos();
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los codigos postales.");
            });
        },

        eliminar(id, cliente) {
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar el cliente?",
                "Eliminar",
                () => {
                    clientesApi.deleteCliente(id).then((response) => {
                        this.$refs.tableCliente.getData();
                        this.respuesta_ok("El cliente ha sido eliminado satisfactoriamente");
                    })
                    .catch((err) => {
                        console.error(err);
                        Notify.ErrorToast(err.response.data.error);
                    });
                }
            );
        },
        listar() {
            this.resetValues();
            this.loading = true;
            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;
        },
        setFilters() {
            let defaultParams = {
                activo: true,
                paginate: true,
                include_padres: true,
            };

            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }

            this.filters = defaultParams;
        },
        async abrirModal(accion, item = null) {
            this.resetValues();
            this.errors.clear();
            this.accion = accion;

            if (accion == "add") {
                this.imagen = "/static/modal/clienteCreate.svg";
                this.titulo_modal = "Registro de cliente";
            } else {
                this.titulo_modal = "Actualizar cliente";
                this.imagen = "/static/modal/clienteUpdate.svg";
                this.cliente.id = item.id;
                this.cliente.nombre = item.nombre;
                this.cliente.telefono = item.telefono;
                this.cliente.correo = item.correo;
                this.cliente.direccion = item.direccion;
                this.estado = item.nombre_estado;
                this.municipio = item.nombre_municipio;
                this.cliente.colonia_id = item.colonia_id;
                this.cliente.nominas = item.nominas;
                await this.getCP(item.cp_id);
            }
            setTimeout(function() {
                document.getElementById("btnModal").click();
            }, 100);
            this.finaliza_carga = true;
        },
        guardar() {
            this.$validator.validate().then((result) => {
                if (result) {
                    this.loading_guardar = true;
                    if (this.accion === "add") {
                        clientesApi.addCliente(this.cliente).then((response) => {
                            this.$refs.tableCliente.getData();
                            this.respuesta_ok("Se creó el nuevo cliente satisfactoriamente.");
                        })
                        .catch((err) => {
                            this.loading_guardar = false;
                            this.respuesta_error(err);
                        });
                    } 
                    else if (this.accion === "update") {
                        delete this.cliente.busca_cp;
                        clientesApi.updateCliente(this.cliente).then((response) => {
                            this.$refs.tableCliente.getData();
                            this.respuesta_ok("Se actualizó el cliente satisfactoriamente.");
                        })
                        .catch((err) => {
                            this.loading_guardar = false;
                            this.respuesta_error(err);
                        });
                    }
                }
            });
        },
        cerrarModal() {
            this.dialog = false;
            this.resetValues();
        },
        resetValues() {
            this.cliente.id = 0;
            this.cliente.nombre = "";
            this.cliente.telefono = "";
            this.cliente.correo = "";
            this.cliente.direccion = "";
            this.cliente.estado_id = null;
            this.cliente.nominas = false;
            this.estado_id = null;
            this.finaliza_carga = false;
            this.codigosP = [];
            this.municipio_id = null;
            this.codigo_postal_id = null;
            this.colonia_id = null;
            this.cliente.cp_id = null;
            this.cliente.municipio_id = null;
            this.cliente.colonia_id = null;
            this.estado = "";
            this.municipio = "";
            this.busca_cp = null;
            this.colonias = [];

            this.loading_guardar = false;
        },
        init() {
            const elementScroll = document.querySelector("#scroll");
            if (elementScroll) {
                const ps = new PerfectScrollbar(elementScroll, {
                wheelSpeed: 2,
                wheelPropagation: true,
                minScrollbarLength: 20,
                suppressScrollY: true,
                });
            }
            $(".ps__thumb-x").css("position", "fixed");
        },
        respuesta_error(err) {
            this.cerrarModal();
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        respuesta_ok(msj) {
            this.listar();
            this.cerrarModal();
            this.resetValues();
            Notify.Success("Operación exitosa", msj);
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
        
    },
    created() {
        this.listar();
    },
    mounted() {
        this.init();
    },
};
</script>
<style scoped>
    .preguntaNomina{
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;
        color: #828282 !important;
        letter-spacing: -0.2px;
        padding-bottom: 20px;
    }
</style>
